import { stringToEnum } from '@snap-types/models/common';

export enum SnapQuoteStatus {
  NEW = 'NEW',
  INPROGRESS = 'INPROGRESS',
  SENT = 'SENT',
  DELETED = 'DELETED',
}

export const snapQuoteStatusSchema = stringToEnum(SnapQuoteStatus);

// NOTE - See parallel definition for Visual at lib/src/enums/quote-won-loss-status.ts
export enum SnapQuoteWonLossStatus {
  COMPLETED = 'Completed',
  CONVERTED = 'Converted',
  LOSS_CAPABILITIES = 'Loss: Capabilities',
  LOSS_CAPABILITIES_NO_QUOTE = 'Loss: Capabilities/No Quote',
  LOSS_CUSTOMER_LOST_BID = 'Loss: Customer lost bid',
  LOSS_EXCEPTIONS_NOT_ACCEPTED = 'Loss: Exceptions not accepted',
  LOSS_LACKING_CERTIFICATION = 'Loss: Lacking Certification',
  LOSS_LEAD_TIME = 'Loss: Lead Time',
  LOSS_PRICE = 'Loss: Price',
  LOSS_QUOTING_FOR_MULTIPLE_CUSTOMERS = 'Loss: Quoting for multiple customers',
  LOSS_QUOTING_FOR_MULTIPLE_REVS_PART_ITERATIONS = 'Loss: Quoting for multiple revs/part iterations',
  LOSS_ROUTINE_COMPETITIVE_CHECK = 'Loss: Routine Competative Check', // Spelling is incorrect in the DB
  LOSS_TERMS_OF_SALE = 'Loss: Terms of Sale',
  PAUSED = 'Paused',
  PENDING_CUSTOMER_RESPONSE = 'Pending Customer Response',
  PENDING_MANUFACTURING = 'Pending Manufacturing',
  PENDING_OUTSIDE_PROCESS = 'Pending Outside Process and/or raw material (Price/Lead Time)',
  PENDING_REVISED_PO_CONTRACT_REVIEW = 'Pending Revised PO (Contract Review)',
  PENDING_REVISED_PO_PRICE = 'Pending Revised PO (Price/Lead Time)',
  QUOTED = 'Quoted',
  RFQ_RECEIVED = 'RFQ Received',
  WIN_CAPABILITIES = 'Win: Capabilities',
  WIN_LEAD_TIME = 'Win: Lead Time',
  WIN_PRICE = 'Win: Price',
}

export const snapQuoteWonLossStatusSchema = stringToEnum(
  SnapQuoteWonLossStatus,
);
